import React from 'react'

import { ProductGridItem } from '@/components/ProductGridItem'

type Props = React.ComponentProps<typeof ProductGridItem>

/*
 * Kept as a named entry point for FeaturedProducts. Since 7e (2026-09-26) the
 * shop grid uses the same peeled-back card, so this just forwards with the
 * featured test id.
 */
export const FeaturedProductCard: React.FC<Props> = (props) => (
  <ProductGridItem {...props} testId="featured-product-card" />
)
